module.exports = __webpack_public_path__ + "img/11.0ba0a693.png";